<template>
  <div>
    <div class="panel limitbox">
      <h2>自己制限</h2>
      <p>ギャンブルの利用を一時的に控えたい場合は、ご希望の期間を選択して自己制限を設定することができます。</p>
      <p>自己制限を有効にすると、設定期間中はアカウントへのログインが制限されます。</p>
      <div class="limit-title">
        自己制限を設定する期間を選択してください。
      </div>
      <fieldset class="limit-fieldset">
        <legend>1日間・7日間・14日間・30日間・無期限</legend>
        <div class="limit-options">
          <label v-for="option in options" :key="option.value">
            <input v-model="selectedDay" name="limit_period" type="radio" :value="option.value">
            {{ option.label }}
          </label>
        </div>
      </fieldset>
      <button class="ctabtn" type="button" :disabled="!selectedDay" @click="isLogin">
        確認
      </button>
      <div class="limit-link">
        <router-link class="rg-action-link" :to="responsibleLink">
          責任あるギャンブルについて ＞
        </router-link>
      </div>
    </div>

    <div v-if="showModal" class="popup-frame popup-self-restraint" :class="{'active': showModal}">
      <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
        <div class="popup-package pop-card-edit">
          <button class="btn-close" href="#" @click="showModal=false" />
          <div class="popup-content">
            <div class="popup-header" />
            <div class="popup-body">
              <p class="text-center">
                有効にすると、この期間中のこのアカ<br>ウントのログインは制限されます
              </p>
              <div class="credit-edit-frame text-center">
                <button id="close" type="button" class="btn btn-secondary btn-style-outline-secondary" @click="logout">
                  確認
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout as localLogout } from '@/utils/user'
import { selfLimitLogin } from '@/api/user'
import { showNotice } from '@/utils/tool'

// 流程沿用 sup-self-restraint.vue；無期限同樣以 365 天送出
const options = [
  { value: 1, label: '1日間' },
  { value: 7, label: '7日間' },
  { value: 14, label: '14日間' },
  { value: 30, label: '30日間' },
  { value: 365, label: '無期限' }
]

export default {
  name: 'TigerSelfRestraint',
  props: {
    // 責任あるギャンブル分頁的路由
    responsibleLink: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options,
      showModal: false,
      selectedDay: null
    }
  },
  methods: {
    isLogin() {
      if (this.$store.getters.token) {
        this.showModal = true
      } else {
        localStorage.setItem('fromSelfRestraint', true)
        this.$router.push('/')
      }
    },
    logout() {
      this.showModal = false

      let timestamp = Math.floor(Date.now() / 1000)
      timestamp += 86400 * this.selectedDay

      selfLimitLogin({ login: timestamp }).then(res => {
        if (res.data.data.code === 0) {
          localLogout()
        } else {
          showNotice(res.data.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

